/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerGetCustomerOfficeAdminsQueryResponse, TransferCustomersControllerGetCustomerOfficeAdminsPathParams, TransferCustomersControllerGetCustomerOfficeAdmins401, TransferCustomersControllerGetCustomerOfficeAdmins403 } from "../../models/transferCustomersController/TransferCustomersControllerGetCustomerOfficeAdmins";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transferCustomersControllerGetCustomerOfficeAdmins } from "../../clients/transfer-customersService/transferCustomersControllerGetCustomerOfficeAdmins";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transferCustomersControllerGetCustomerOfficeAdminsQueryKey = (salesforceId: TransferCustomersControllerGetCustomerOfficeAdminsPathParams["salesforceId"]) => [{
  url: '/api/v1/transfer-customers/:salesforceId/office-admins',
  params: {
    salesforceId: salesforceId
  }
}] as const;
export type TransferCustomersControllerGetCustomerOfficeAdminsQueryKey = ReturnType<typeof transferCustomersControllerGetCustomerOfficeAdminsQueryKey>;
export function transferCustomersControllerGetCustomerOfficeAdminsQueryOptions(salesforceId: TransferCustomersControllerGetCustomerOfficeAdminsPathParams["salesforceId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transferCustomersControllerGetCustomerOfficeAdminsQueryKey(salesforceId);
  return queryOptions<TransferCustomersControllerGetCustomerOfficeAdminsQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetCustomerOfficeAdmins401 | TransferCustomersControllerGetCustomerOfficeAdmins403>, TransferCustomersControllerGetCustomerOfficeAdminsQueryResponse, typeof queryKey>({
    enabled: !!salesforceId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transferCustomersControllerGetCustomerOfficeAdmins(salesforceId, config);
    }
  });
}

/**
 * @summary Get distinct active office administrators for a customer (1.0 teams + svc-permissions)
 * {@link /api/v1/transfer-customers/:salesforceId/office-admins}
 */
export function useTransferCustomersControllerGetCustomerOfficeAdmins<TData = TransferCustomersControllerGetCustomerOfficeAdminsQueryResponse, TQueryData = TransferCustomersControllerGetCustomerOfficeAdminsQueryResponse, TQueryKey extends QueryKey = TransferCustomersControllerGetCustomerOfficeAdminsQueryKey>(salesforceId: TransferCustomersControllerGetCustomerOfficeAdminsPathParams["salesforceId"], options: {
  query?: Partial<QueryObserverOptions<TransferCustomersControllerGetCustomerOfficeAdminsQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetCustomerOfficeAdmins401 | TransferCustomersControllerGetCustomerOfficeAdmins403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transferCustomersControllerGetCustomerOfficeAdminsQueryKey(salesforceId);
  const query = useQuery({
    ...transferCustomersControllerGetCustomerOfficeAdminsQueryOptions(salesforceId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransferCustomersControllerGetCustomerOfficeAdmins401 | TransferCustomersControllerGetCustomerOfficeAdmins403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}